import { render, staticRenderFns } from "./Medicamento.vue?vue&type=template&id=23b570d9&scoped=true"
import script from "./Medicamento.vue?vue&type=script&lang=js"
export * from "./Medicamento.vue?vue&type=script&lang=js"
import style0 from "./Medicamento.vue?vue&type=style&index=0&id=23b570d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b570d9",
  null
  
)

export default component.exports